import { ReportsActionTypes, ReportsState } from './types';
import { Reducer } from 'redux';

const initialState: ReportsState = {};

const reducer: Reducer<ReportsState | null> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case ReportsActionTypes.FETCH_REPORTS: {
      return {
        ...state,
        isReportLoading: true
      };
    }

    case ReportsActionTypes.FETCH_REPORTS_SUCCESS: {
      state = {
        ...state,
        isReportLoading: false
      };
      return state;
    }
    case ReportsActionTypes.FETCH_REPORTS_FAILURE: {
      state = {
        ...state,
        isReportLoading: false,
        error: action.payload
      };
      return state;
    }
    case ReportsActionTypes.SET_REPORT_TOKEN_TYPES: {
      return {
        ...state,
        loading: true
      };
    }
    case ReportsActionTypes.SET_REPORT_TOKEN_SUCCESS: {
      return {
        ...state,
        loading: true,
        token: action.payload
      };
    }
    case ReportsActionTypes.SET_REPORT_TOKEN_FAILURE: {
      state = {
        ...state,
        loading: false,
        error: action.payload
      };
      return state;
    }

    case ReportsActionTypes.SET_REPORT_TYPES_SUCCESS: {
      return {
        ...state,
        loading: false,
        resources: action.payload?.resourceLookup || []
      };
    }
    case ReportsActionTypes.SET_REPORT_TYPES_FAILURE: {
      state = {
        ...state,
        loading: false,
        error: action.payload
      };
      return state;
    }

    case ReportsActionTypes.FETCH_REPORT_FILTERS_REQUEST: {
      return {
        ...state,
        filterLoader: true
      };
    }
    case ReportsActionTypes.FETCH_REPORT_FILTERS_SUCCESS: {
      return {
        ...state,
        filterLoader: false,
        inputControls: action.payload?.inputControl || []
      };
    }
    case ReportsActionTypes.FETCH_REPORT_FILTERS_FAILURE: {
      state = {
        ...state,
        filterLoader: false,
        error: action.payload
      };
      return state;
    }
    case ReportsActionTypes.SET_REPORTS_INITIAL_STATE: {
      return {};
    }

    default:
      return state;
  }
};

export { reducer as ReportsReducer };
